import { transport } from 'config/transport';

export function callApiExportCongDoanReportForAllCongDoan(academicYear) {
    return transport.get(`/trunguong/report/congdoan/annually`, { params: { academicYear }, responseType: 'blob' });
}
